<template>
  <!-- v-if="
    component != null && component.type != null && component.properties != null
  "-->
  <OneCol
    v-if="component.type == 'subsection-1-column'"
    :properties="component.properties"
    :variant_color="variant_color"
  />
  <TwoCols
    v-else-if="component.type == 'subsection-2-columns'"
    :properties="component.properties"
    :variant_color="variant_color"
  />
  <ThreeCols
    v-else-if="component.type == 'subsection-3-columns'"
    :properties="component.properties"
    :variant_color="variant_color"
  />
  <About
    v-else-if="component.type == 'subsection-about'"
    :properties="component.properties"
    :variant_color="variant_color"
  />
  <Contact
    v-else-if="component.type == 'subsection-contact'"
    :properties="component.properties"
    :variant_color="variant_color"
  />
  <Grid
    v-else-if="component.type == 'subsection-grid'"
    :properties="component.properties"
    :variant_color="variant_color"
  />
  <Introduction
    v-else-if="component.type == 'subsection-intro'"
    :properties="component.properties"
    :variant_color="variant_color"
  />
  <Drawer
    v-else-if="component.type == 'drawer'"
    :properties="component.properties"
  />
</template>

<script>
export default {
  name: "FactorySubSection",
  components: {
    OneCol: () =>
      /* webpackChunkName: "comp-[request]" */ import("./SubSections/1Col"),
    TwoCols: () =>
      /* webpackChunkName: "comp-[request]" */ import("./SubSections/2Cols"),
    ThreeCols: () =>
      /* webpackChunkName: "comp-[request]" */ import("./SubSections/3Cols"),
    Contact: () =>
      /* webpackChunkName: "comp-[request]" */ import("./SubSections/Contact"),
    Grid: () =>
      /* webpackChunkName: "comp-[request]" */ import("./SubSections/Grid"),
    Introduction: () =>
      /* webpackChunkName: "comp-[request]" */ import(
        "./SubSections/Introduction"
      ),
    Drawer: () =>
      /* webpackChunkName: "comp-[request]" */ import("./Components/Drawer")
  },
  props: {
    component: {
      type: Object,
      default: null
    },
    variant_color: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    }
  }
};
</script>
